import React, { useState, useEffect, useContext } from 'react';
import MaterialTable from 'material-table';
import CircularLoading from "../components/CircularLoading";
import { useSelector, useDispatch } from "react-redux";
import ConfirmationDialogRaw from '../components/ConfirmationDialogRaw';
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import { Portal } from "react-overlays";
import { Button } from '@material-ui/core';
import {
  features,
  dateStyle,
  language
} from 'config';
import { makeStyles } from '@material-ui/core/styles';
import { FirebaseContext } from 'common';
//import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
//styles for the grid user interface
const styles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
}));


const BookingHistory = () => {
  const { api } = useContext(FirebaseContext);
  const {
    cancelBooking
  } = api;
  const dispatch = useDispatch();
  const auth = useSelector(state => state.auth);
  const [role, setRole] = useState(null);
  //date constants for the date range picker
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const CalendarContainer = ({ children }) => {
    const el = document.getElementById("calendar-portal");

    return <Portal container={el}>{children}</Portal>;
  };

  const columns = [
    //{ title: language.booking_id, field: 'id' },
    { title: language.booking_date, field: 'tripdate', render: rowData => rowData.tripdate ? new Date(rowData.tripdate).toLocaleString(dateStyle) : null },
    { title: language.car_type, field: 'carType' },
    { title: language.customer_name, field: 'customer_name' },
    { title: language.pickup_address, field: 'pickupAddress' },
    { title: language.drop_address, field: 'dropAddress' },
    { title: language.assign_driver, field: 'driver_name' },
    { title: language.booking_status, field: 'status' },
    { title: language.otp, field: 'otp', render: rowData => rowData.status === 'NEW' || rowData.status === 'ACCEPTED' ? <span>{rowData.otp}</span> : null },
    { title: language.trip_cost, field: 'trip_cost' },
    { title: language.payment_status, field: 'payment_status' },

    /* More Fields if you need

    { title: language.trip_start_time, field: 'trip_start_time' },
    { title: language.trip_end_time, field: 'trip_end_time' },
    { title: language.vehicle_no, field: 'vehicle_number' },  
    { title: language.trip_cost_driver_share, field: 'driver_share'},
    { title: language.convenience_fee, field: 'convenience_fees'},
    { title: language.discount_ammount, field: 'discount'},      
    { title: language.Customer_paid, field: 'customer_paid'},
    { title: language.payment_mode, field: 'payment_mode'},
    { title: language.payment_gateway, field: 'gateway'},
    { title: language.cash_payment_amount, field: 'cashPaymentAmount'},
    { title: language.card_payment_amount, field: 'cardPaymentAmount'},
    { title: language.wallet_payment_amount, field: 'usedWalletMoney'},

    */

  ];
  const [data, setData] = useState([]);
  const [changedData, setChangedData] = useState([]);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState('');
  const bookinglistdata = useSelector(state => state.bookinglistdata);
  const classes = styles();

  useEffect(() => {
    if (bookinglistdata.bookings) {
      setData(bookinglistdata.bookings.reverse());
    } else {
      setData([]);
    }
  }, [bookinglistdata.bookings]);
  // initialising changed data with booking data
  useEffect(() => {
    if (bookinglistdata.bookings) {
      setChangedData(bookinglistdata.bookings);
    } else {
      setChangedData([]);
    }
  }, [bookinglistdata.bookings]);

  useEffect(() => {
    if (auth.info && auth.info.profile) {
      setRole(auth.info.profile.usertype);
    }
  }, [auth.info]);

  const onConfirmClose = (value) => {
    if (value) {
      dispatch(cancelBooking({
        reason: value,
        booking: selectedBooking
      }));
    }
    setOpenConfirm(false);
  }

  //function that filters the bookinglistdata by the entered time range 
  var resultBookingData = data.filter(a => {
    var date = new Date(a.tripdate);
    return (date >= startDate && date <= endDate);
  });

  const changeData = () => {
    // setChangedData(resultBookingData)
    if (resultBookingData) {
      setChangedData(resultBookingData);
    }
    //  else{
    //    setChangedData(data);
    //  }
  }

  return (
    bookinglistdata.loading ? <CircularLoading /> :
      <div>
        <div>
          {/* <MaterialTable
            title={language.booking_title}
            columns={columns}
            data={data}

            options={{
              actionsColumnIndex: -1
            }}
            actions={[
              rowData => ({
                icon: 'cancel',
                tooltip: language.cancel_booking,
                disabled: rowData.status === 'NEW' || rowData.status === 'ACCEPTED' ? false : true,
                onClick: (event, rowData) => {
                  if (features.AllowCriticalEditsAdmin && (role === 'rider' || role === 'admin')) {
                    setSelectedBooking(rowData);
                    setOpenConfirm(true);
                  } else {
                    alert('Cancellation is Restricted.');
                  }
                }
              }),
            ]}
          />
          <ConfirmationDialogRaw
            open={openConfirm}
            onClose={onConfirmClose}
            value={''}
          /> */}
        </div>
        <br />
        <div className={classes.root}>
          <Grid container spacing={24}>
            <Grid item xs={4} sm={2}>
              <Paper className={classes.paper}>
                <p>Select Days</p>
              </Paper>
            </Grid>
            <Grid item xs={4} sm={2}>
              <Paper className={classes.paper}>
                <p>
                <DatePicker
                  className='form-control datepicker'
                  selected={startDate}
                  onChange={date => setStartDate(date)}
                  selectsStart
                  startDate={startDate}
                  id='start-date'
                  endDate={endDate}
                  popoverAttachment='top right'
                  popperContainer={CalendarContainer}
                />
                </p>
              </Paper>
            </Grid>
            <Grid item xs={4} sm={2}>
              <Paper className={classes.paper}>
                <p>
                <DatePicker
                  className='form-control datepicker'
                  selected={endDate}
                  onChange={date => setEndDate(date)}
                  selectsEnd
                  startDate={startDate}
                  endDate={endDate}
                  minDate={startDate}
                  popoverTargetAttachment='top right'
                />
                </p>
              </Paper>
            </Grid>
            <Grid item xs={4} sm={2}>
              <Paper className={classes.paper}>
                <Button
                  size="small"
                  onClick={changeData}
                  variant="contained"
                  color="primary"
                >
                  Confirm
            </Button>
              </Paper>
            </Grid>
          </Grid>
        </div>
        <br />
        <div>
          <MaterialTable
            title={language.booking_title}
            columns={columns}
            data={changedData}
            style={{
              border: "2px solid gray",
              maxWidth: "1450px",
              overflow: "scroll",
              marginTop: "10px",
              marginLeft: "20px",
            }}

            options={{
              actionsColumnIndex: -1,
              exportButton: true,
              draggable: true,
              grouping: true,
              tableLayout: "auto",
              headerStyle: {
                backgroundColor: '#144216',
                color: '#FFF',
                // "&:hover":{
                //   color: "blue"
                // }
              },
            }}
            actions={[
              rowData => ({
                icon: 'cancel',
                tooltip: language.cancel_booking,
                disabled: rowData.status === 'NEW' || rowData.status === 'ACCEPTED' ? false : true,
                onClick: (event, rowData) => {
                  if (features.AllowCriticalEditsAdmin && (role === 'rider' || role === 'admin')) {
                    setSelectedBooking(rowData);
                    setOpenConfirm(true);
                  } else {
                    alert('Cancellation is Restricted.');
                  }
                }
              }),
            ]}
          />
          <ConfirmationDialogRaw
            open={openConfirm}
            onClose={onConfirmClose}
            value={''}
          />

        </div>



      </div>

  );
}
export default BookingHistory;
